export default {"src":"/_next/static/media/GuideIcon.f1586802.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};